/* eslint-disable */

export const parseHexColor = (hex) => {
  // Fornece um fallback para preto se hex for null, undefined ou string vazia
  const cleanHexInput = hex || "#000000";
  const cleanHex = cleanHexInput.replace("#", "");

  // Validação básica do formato hexadecimal
  if (!/^[0-9A-F]{6}$/i.test(cleanHex) && !/^[0-9A-F]{3}$/i.test(cleanHex)) {
    console.warn(
      `Invalid hex color provided to parseHexColor: ${hex}. Defaulting to black.`
    );
    return { r: 0, g: 0, b: 0 }; // Default para preto se inválido
  }

  let r, g, b;
  if (cleanHex.length === 3) {
    r = parseInt(cleanHex[0] + cleanHex[0], 16);
    g = parseInt(cleanHex[1] + cleanHex[1], 16);
    b = parseInt(cleanHex[2] + cleanHex[2], 16);
  } else {
    r = parseInt(cleanHex.substring(0, 2), 16);
    g = parseInt(cleanHex.substring(2, 4), 16);
    b = parseInt(cleanHex.substring(4, 6), 16);
  }

  // Garante que são números, senão default para 0
  return {
    r: isNaN(r) ? 0 : r,
    g: isNaN(g) ? 0 : g,
    b: isNaN(b) ? 0 : b,
  };
};
export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export const lightenColor = (hex, amount = 40) => {
  const { r, g, b } = parseHexColor(hex);
  return {
    r: clamp(r + amount, 0, 255),
    g: clamp(g + amount, 0, 255),
    b: clamp(b + amount, 0, 255),
  };
};

export const darkenColor = (hex, amount = 40) => {
  const { r, g, b } = parseHexColor(hex);
  return {
    r: clamp(r - amount, 0, 255),
    g: clamp(g - amount, 0, 255),
    b: clamp(b - amount, 0, 255),
  };
};

export const hexToRgbArray = (hex) => {
  const cleanHex = hex.replace("#", "");
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return [r, g, b];
};

export const pastelColorToRgb = (baseColor) => {
  let pastelHex = "#FFFFFF";
  switch (baseColor.toLowerCase()) {
    case "#4caf50": // green
      pastelHex = "#C8E6C9";
      break;
    case "#ffeb3b": // yellow
      pastelHex = "#FFF9C4";
      break;
    case "#f44336": // red
      pastelHex = "#FFCDD2";
      break;
    // Adicione mais cores base se necessário
    default:
      pastelHex = "#FFFFFF"; // Fallback para branco ou outra cor pastel padrão
  }
  return hexToRgbArray(pastelHex);
};

export function getAlphaColor(hex, level) {
  // Se for nível 0 (linha raiz), pode retornar sem cor:
  if (level === 0) {
    return "transparent";
  }
  // Se for nível > 0, defina a lógica inversa:
  // Por exemplo, alpha base = 0.15 no primeiro filho, e vá reduzindo 0.05 a cada nível.
  const alphaFirstChild = 0.08; // cor mais forte no nível 1
  const decrement = 0.04; // reduz a cada novo nível
  let alpha = alphaFirstChild - decrement * (level - 1);
  // Garante que não fique abaixo de 0.05:
  if (alpha < 0.05) {
    alpha = 0.05;
  }

  // AGORA parseHexColor retorna um objeto {r, g, b}
  const colorObj = parseHexColor(hex); // colorObj será {r, g, b}
  // Verifique se colorObj não é null ou undefined, embora parseHexColor agora tenha fallback
  if (!colorObj) {
    console.warn(
      `getAlphaColor recebeu hex inválido ou parseHexColor falhou para: ${hex}`
    );
    return `rgba(0, 0, 0, ${alpha})`; // Fallback para preto com alpha
  }

  return `rgba(${colorObj.r}, ${colorObj.g}, ${colorObj.b}, ${alpha})`;
}

/**
 * Lightens a color by mixing it with white, based on a percentage.
 * This is more predictable than adding a fixed amount.
 * @param {string} hex - The base hex color (e.g., "#4A90E2").
 * @param {number} percentage - How much to lighten, from 0.0 (no change) to 1.0 (fully white).
 *                              e.g., 0.8 would be a very light tint.
 * @returns {{r: number, g: number, b: number}} The resulting RGB color.
 */
export const lightenByPercentage = (hex, percentage) => {
  const { r: colorR, g: colorG, b: colorB } = parseHexColor(hex);
  const white = 255;

  // The weight of white in the mix
  const p = Math.max(0, Math.min(1, percentage));

  const r = Math.round(colorR * (1 - p) + white * p);
  const g = Math.round(colorG * (1 - p) + white * p);
  const b = Math.round(colorB * (1 - p) + white * p);

  // You already have a clamp function, so this is very safe
  return {
    r: clamp(r, 0, 255),
    g: clamp(g, 0, 255),
    b: clamp(b, 0, 255),
  };
};
